var render = function render(){var _vm=this,_c=_vm._self._c;return _c('school-page',{attrs:{"banner-title":"прикрепление к&nbsp;школе и&nbsp;онлайн-аттестации","banner-subtitle":"прикрепитесь к&nbsp;нашей онлайн-школе в&nbsp;любое время года и&nbsp;сдавайте итоговые и&nbsp;промежуточные аттестации&nbsp;онлайн"}})
}
var staticRenderFns = []

export { render, staticRenderFns }